import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import {
  Pool,
  PoolAdditionalData,
} from '../../../../../../../../apis/pool.api';
import { IProduct } from '../../../../../IProduct';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P0003600 } from '../../../../P0003600';
import { P0003601 } from '../../../../P0003601';
import { P0004700 } from '../../../../P0004700';
import { P00046 } from '../../../../P00046';
import { P0003605ESPInstallationClComponent } from '../../../../P0003605/InjectionChlore/EnSavoirPlus/p0003605-espinstallation-cl/p0003605-espinstallation-cl.component';
import { HeaderConfigurationComponent } from '../../../../../../../../components/ecosystems/header-configuration/header-configuration.component';
import { IonButton, IonContent } from '@ionic/angular/standalone';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { SwitchConfigurationComponent } from '../../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { TranslatePipe } from '@ngx-translate/core';
import { P0003606ConsigneRegulationPh } from '../../../Enum/P0003606ConsigneRegulationPh';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { P0003606TypeCorrecteurPh } from '../../../Enum/P0003606TypeCorrecteurPh';
import { P0003606ESPInstallationPhComponent } from '../../../EnSavoirPlus/p0003606-espinstallation-ph/p0003606-espinstallation-ph.component';
import { FunctionEnSavoirPlusModalComponent } from '../../../../../../../../components/ecosystems/function-en-savoir-plus-modal/function-en-savoir-plus-modal.component';

@Component({
  selector: 'app-p0003606-injection-ph-miseen-oeuvre-regulation',
  templateUrl:
    './p0003606-injection-ph-miseen-oeuvre-regulation.component.html',
  styleUrls: [
    './p0003606-injection-ph-miseen-oeuvre-regulation.component.scss',
  ],
  imports: [
    HeaderConfigurationComponent,
    IonButton,
    IonContent,
    LabelConfigurationComponent,
    LabelDescriptionComponent,
    SwitchConfigurationComponent,
    TranslatePipe,
  ],
})
export class P0003606InjectionPhMiseenOeuvreRegulationComponent
  implements OnInit
{
  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private slideModalController: SlideModalController =
    inject(SlideModalController);
  @Input() prev: () => void = () => {};
  @Input() next: (
    actionStack: DeviceActionStackService,
    poolAdditionalData: PoolAdditionalData,
  ) => void = () => {};

  @Input() productClass: IProduct | null = null;

  @Input() poolAdditionalData: PoolAdditionalData | null = null;

  @Input() actionStackParam: any | null = null;
  actionStack: DeviceActionStackService | null = null;

  @Input() pool: Pool | null = null;

  constructor() {
    this.P0003606ESPInstallationPh = this.P0003606ESPInstallationPh.bind(this);
    this.P0003606TypeCorrecteurPhModal =
      this.P0003606TypeCorrecteurPhModal.bind(this);
  }

  hasProduitP0003600() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P0003600()) ?? 0;
  }

  hasProduitP0003601() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P0003601()) ?? 0;
  }

  hasProduitP0004700() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P0004700()) ?? 0;
  }

  hasProduitP00046() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00046()) ?? 0;
  }

  async P0003606ESPInstallationPh() {
    const modal = await this.slideModalController.create({
      component: P0003606ESPInstallationPhComponent,
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  async P0003606TypeCorrecteurPhModal() {
    const modal = await this.slideModalController.create({
      component: FunctionEnSavoirPlusModalComponent,
      componentProps: {
        description: 'P0003606.installation.correcteur.ensavoirplus',
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      this.actionStackParam,
    );
  }

  onSubmit() {
    this.next(this.actionStack!, this.poolAdditionalData!);
  }

  protected readonly P0003606ConsigneRegulationPh =
    P0003606ConsigneRegulationPh;
  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P0003606TypeCorrecteurPh = P0003606TypeCorrecteurPh;
}
